import { render, staticRenderFns } from "./Q_ExtentionTube.vue?vue&type=template&id=2cec5a92"
import script from "./Q_ExtentionTube.vue?vue&type=script&lang=js"
export * from "./Q_ExtentionTube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports